module.exports = __webpack_public_path__ + "static/thedormantoffice-b716e0f262f7a248f21f5b09b7dc557b.jpg";